<script>
import {Line} from 'vue-chartjs'
import ChartDataLabels from "chartjs-plugin-labels";

Chart.plugins.unregister(ChartDataLabels);

export default {
    extends: Line,
    props: {
        chartData: {
            type: Object,
            required: true,
        },
        options: {
            type: String,
        }
    },
    mounted() {
        let options = Object.assign({
            responsive: true,
            maintainAspectRatio: false,
            width: 420,
            height: 300,
        }, this.options ? JSON.parse(this.options) : {})
        if (options.showPercent && options.showPercent == true) {
            options = Object.assign({
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return tooltipItem.value + ' %';
                        }
                    }
                }
            }, options);
        }
        this.addPlugin(ChartDataLabels);
        this.renderChart(this.chartData, options)
    }
}
</script>
